module.exports = __webpack_public_path__ + "static/img/bottom_ico.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom_ico.png
// module id = C0dr
// module chunks = 14